import { PIG_BEACH_SILHOUETTES, BRACKENMOOR_SILHOUETTES, COIL_UNDERCROFT_SILHOUETTES } from './coilParallaxSilhouettes';
import { LANDSCAPE_BACKDROPS } from './landscapeBackdrops';
import { placeWorldShape, type WorldBackdrop } from './worldShapeKit';

/** Keep the exact Coil Light art, mounting and corruption treatment. Only the
 * repeatable landscape changes: wide coastal palms, ragged inland crags, and
 * broken arch buttresses inside the spiral. Excluded town art is never edited. */
export const COIL_WORLD_BACKDROPS = {
  beach: {
    far: PIG_BEACH_SILHOUETTES.far,
    mid: LANDSCAPE_BACKDROPS.coast.mid,
    near: LANDSCAPE_BACKDROPS.coast.near,
  },
  bracken: {
    far: LANDSCAPE_BACKDROPS.moor.far,
    mid: LANDSCAPE_BACKDROPS.drowned.mid,
    near: BRACKENMOOR_SILHOUETTES.near,
  },
  undercroft: {
    far: {
      tile: {
        ...COIL_UNDERCROFT_SILHOUETTES.far.tile,
        path: COIL_UNDERCROFT_SILHOUETTES.far.tile.path + ' '
          + placeWorldShape('ruin', 100, 1000, 750, 880) + ' '
          + placeWorldShape('ruin', 1080, 1000, 750, 790),
      },
    },
    mid: COIL_UNDERCROFT_SILHOUETTES.mid,
    near: COIL_UNDERCROFT_SILHOUETTES.near,
  },
} satisfies Record<string, WorldBackdrop>;
